export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8571.a3188031.jpg";